import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import { Link, useNavigate } from "react-router-dom";
import { Bounce, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import Footer from "../Footer";
import axios from "axios";
import CarCard from "../components/CarCard";

const ViewMyCarlist = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const getDataFromlocalStorage = (key) => {
    try {
      const serializedData = localStorage.getItem(key);
      return serializedData ? JSON.parse(serializedData) : null;
    } catch (error) {
      console.error("Error getting data from localStorage:", error);
      return null;
    }
  };
  const optionToast = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    transition: Bounce,
  };
  const storedUserPreferences = getDataFromlocalStorage("userData");
  useEffect(() => {
    if (storedUserPreferences === null) {
      Swal.fire({
        title: "Unauthorized",
        text: "You need to be logged in to access this page",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00889C",
        cancelButtonColor: "#d33",
        confirmButtonText: "Log In Now",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/login");
        } else {
          navigate("/");
        }
      });
      return;
    } else if (storedUserPreferences?.role !== "dealer") {
      Swal.fire({
        title: "Unauthorized Access",
        text: "Only dealer can access this!",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#00889C",
        cancelButtonColor: "#d33",
        confirmButtonText: "Back To Home",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/");
        } else {
          navigate("/");
        }
      });
      return;
    }
  }, []);

  const getAllMyCar = async () => {
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/publish/car/list",
        {
          owner_id: storedUserPreferences?.id,
        }
      );

      if (response?.data?.status) {
        setData(response?.data?.data);
      }
    } catch (error) {
      console.log("An error occurred while fetching data.", error);
    }
  };
  const publishedMyCar = () => {
    setLoading(true);
    const formData = {
      owner_id: storedUserPreferences?.id,
    };

    axios
      .post(
        window.CARLOCA_API + "/car/save-for-publish",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((res) => {
        setLoading(false);
        if (res?.data?.status) {
          getAllMyCar();
          toast.success("All Cars Successfully Published");
        } else {
          toast.error(res?.data?.message, optionToast);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  const saveDraftMyCars = () => {
    setLoading2(true);
    const formData = {
      owner_id: storedUserPreferences?.id,
    };

    axios
      .post(
        window.CARLOCA_API + "/car/save-draft",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((res) => {
        setLoading2(false);
        if (res?.data?.status) {
          getAllMyCar();
          toast.success("All cars successfully saved as drafts");
        } else {
          toast.error(res?.data?.message, optionToast);
        }
      })
      .catch((err) => {
        setLoading2(false);
        console.log(err);
      });
  };
  useEffect(() => {
    getAllMyCar();
  }, []);

  const deleteMyCar = async (id) => {
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/publish/car/delete",
        {
          car_id: id,
          owner_id: storedUserPreferences?.id,
        }
      );

      if (response?.data?.status) {
        getAllMyCar();
      } else {
        alert(response?.data?.message);
      }
    } catch (error) {
      console.log("An error occurred while fetching data.", error);
    }
  };
  const editMyCar = async (id) => {
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/publish/edit/car",
        {
          car_id: id,
          owner_id: storedUserPreferences?.id,
        }
      );

      if (response?.data?.status) {
        navigate("/dealer/edit-saved/publish/cars", {
          state: { data: response?.data?.data },
        });
      } else {
        alert(response?.data?.message);
      }
    } catch (error) {
      console.log("An error occurred while fetching data.", error);
    }
  };
  const handleDelete = (id) => {
    const userConfirmed = window.confirm(
      "are you sure you want to delete the car data ?"
    );
    if (userConfirmed) {
      deleteMyCar(id);
    }
  };

  return (
    <>
      <Navbar />
      <div className="cl-page">
        <div className="container">
          <div className="d-flex align-items-center justify-content-between w-100 mb-4 flex-wrap gap-2">
            <div>
              <h3 className="cl-page-title">Review Your Car Listings</h3>
              <p className="cl-page-subtitle">Preview your listings before publishing</p>
            </div>
            <Link to="/dealer/list-my-cars" className="cl-btn cl-btn-primary cl-btn-sm">
              <i className="fa-solid fa-plus me-1"></i>Add More
            </Link>
          </div>
          <p className="text-muted mb-4" style={{ fontSize: '.88rem' }}>
            Here's a preview of your listings. Click 'Publish Your Cars' to submit. To amend a listing please visit your dashboard.
          </p>

          <div className="row g-3">
            {data.length === 0 ? (
              <div className="col-12 d-flex flex-column align-items-center my-4">
                <div className="cl-empty">
                  <div className="cl-empty-icon"><i className="fa-solid fa-car"></i></div>
                  <h6 className="cl-empty-title">No Car Listed Yet</h6>
                  <p className="cl-empty-text">You haven&#39;t listed any cars yet.</p>
                  <Link to="/dealer/dashboard" className="cl-btn cl-btn-primary cl-btn-sm">Back To Dashboard</Link>
                </div>
              </div>
            ) : (
              <>
                {data.map((car) => (
                  <div
                    key={car.id}
                    className="col-xxl-3 col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6"
                  >
                    <CarCard
                      carData={car}
                      linkTo={`/dealer/saved/car/detail?car=${car?.slug}`}
                      topLeftContent={
                        <button
                          className="btn btn-sm btn-danger"
                          style={{ border: "none", cursor: "pointer", borderRadius: "6px", padding: "4px 8px" }}
                          onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleDelete(car.id); }}
                        >
                          <i className="fa fa-trash" style={{ color: "white", fontSize: "13px" }}></i>
                        </button>
                      }
                      topRightContent={
                        <button
                          className="btn btn-sm btn-primary"
                          style={{ border: "none", cursor: "pointer", borderRadius: "6px", padding: "4px 8px" }}
                          onClick={(e) => { e.preventDefault(); e.stopPropagation(); editMyCar(car.id); }}
                        >
                          <i className="fa fa-edit" style={{ color: "white", fontSize: "13px" }}></i>
                        </button>
                      }
                    />
                  </div>
                ))}
                <div className="col-12 d-flex flex-column align-items-center mt-4">
                  <button
                    type="button"
                    disabled={loading}
                    onClick={publishedMyCar}
                    className="btn px-5 py-2"
                    style={{ background: "linear-gradient(135deg, #00889c, #006f80)", color: "#fff", borderRadius: "50px", fontWeight: 600, fontSize: "14px", border: "none", boxShadow: "0 4px 15px rgba(0,136,156,0.35)" }}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Processing...
                      </>
                    ) : (
                      " Publish Your Cars"
                    )}
                  </button>
                  <button
                    type="button"
                    disabled={loading2}
                    onClick={saveDraftMyCars}
                    className="btn px-5 py-2 mt-3"
                    style={{ background: "linear-gradient(135deg, #555, #333)", color: "#fff", borderRadius: "50px", fontWeight: 600, fontSize: "14px", border: "none" }}
                  >
                    {loading2 ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Processing...
                      </>
                    ) : (
                      "Save As Draft"
                    )}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <Footer />
      <ToastContainer />
    </>
  );
};

export default ViewMyCarlist;
